"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomChip = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _Chip = _interopRequireDefault(require("@mui/material/Chip"));

var _DeleteForeverOutlined = _interopRequireDefault(require("@mui/icons-material/DeleteForeverOutlined"));

var _jsxRuntime = require("react/jsx-runtime");

var CustomChip = function CustomChip(_ref) {
  var key = _ref.key,
      label = _ref.label,
      onDelete = _ref.onDelete,
      showDelete = _ref.showDelete;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var handleMouseEnter = function handleMouseEnter() {
    setIsHovered(true);
  };

  var handleMouseLeave = function handleMouseLeave() {
    setIsHovered(false);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.default, {
    label: label,
    onDelete: onDelete,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    deleteIcon: showDelete ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeleteForeverOutlined.default, {
      sx: {
        color: "#B64545!important",
        fontSize: "14px!important",
        cursor: "pointer"
      }
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeleteForeverOutlined.default, {
      sx: {
        display: "none"
      }
    }),
    style: {
      height: "30px",
      borderRadius: "5px",
      background: "transparent",
      border: "1px solid ".concat(showDelete && isHovered ? "#B64545" : "#F0F0F0"),
      color: "".concat(showDelete && isHovered ? "#B64545" : "#707070")
    }
  }, key);
};

exports.CustomChip = CustomChip;